module.exports = "/_next/static/images/game-1-phone-attachment-knife-de9f06f6a7e062a62dd31a054d310d06.jpg";